<template>
  <!-- 求职意向组件 -->
  <!-- ApplyForAJob 和 certain 都等于1时 正常显示求职意向 若有一条不等于1说明用户点击了添加或单条编辑 这时就要展示编辑栏 -->
  <div :class="certain == 1 ? 'normal' : 'editor'">
    <div class="Title-Add-box">
      <div class="Title-Add" @click="handelClickEDITOR"></div>
      <p class="Title-p" @click="handelClickEDITOR">添加求职意向</p>
    </div>
    <!-- 正常显示求职意向 -->
    <div v-if="certain == 1" class="NormalDisplay">
      <!-- 求职意向没有数据 展示待添加 -->
      <div class="None firm-clickable" v-if="data.length == 0" @click="handelClickEDITOR">
        待添加
      </div>
      <!-- 求职意向有数据正常展示数据 -->
      <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="normal-show-box">
          <p class="Position-name">{{ item.positionName }}</p>
          <div :class="item.jobType == '1' ? 'Part-time' : 'full-time'"></div>
          <div
            class="Edit-button firm-clickable"
            @click="handelIndividualEdit(item, index)"
          ></div>
        </div>
        <div class="normal-show-box">
          <p>
            期望薪资：{{
              item.hopeMaxSalary != "" &&
              item.hopeMaxSalary != null &&
              item.hopeMaxSalary != 0
                ? item.hopeMinSalary + "-" + item.hopeMaxSalary + "元"
                : "面议"
            }}
          </p>
          <p>期望地点：{{ item.addressName }}</p>
          <p>
            期望行业：
            {{ item.industryTypeName }}
          </p>
        </div>
      </div>
    </div>
    <!-- 显示求职意向的编辑栏 -->
    <div v-if="certain == 2" class="StartEditing">
      <div class="EDITOR-top">
        <!-- input右侧标题 -->
        <div class="EDITOR-top-title">
          <p v-for="(item, index) in userArr" :key="index">
            <span v-if="item.required == '1'" style="color: red">*</span
            >{{ item.name }}：
          </p>
        </div>
        <!-- 右侧 ipt框 -->
        <div class="EDITOR-top-ipt">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 期望职位框 -->
            <div class="input-place" @click="handelExpect(1)">
              <el-form-item prop="positionName">
                <el-input
                  v-model="ruleForm.positionName"
                  placeholder="请选择"
                  readonly
                ></el-input>
              </el-form-item>
            </div>
            <!-- 期望行业框 -->
            <div class="input-place" @click="handelExpect(2)">
              <el-form-item prop="industryTypeName">
                <el-input
                  v-model="ruleForm.industryTypeName"
                  placeholder="请选择"
                  readonly
                ></el-input>
              </el-form-item>
            </div>
            <!-- 期望地点框 -->
            <div class="input-place" @click="handelExpect(3)">
              <el-form-item prop="addressName">
                <el-input
                  v-model="ruleForm.addressName"
                  placeholder="请选择"
                  readonly
                ></el-input>
              </el-form-item>
            </div>
            <!-- 期望薪资框 -->
            <div class="input-place">
              <el-form-item prop="hopeMinSalary">
                <el-select
                  v-model="ruleForm.hopeMinSalary"
                  placeholder="请选择"
                  @change="handelChange"
                  
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="SelectTo" v-show="ruleForm.hopeMinSalary != 0">至</div>
              <el-form-item prop="hopeMaxSalary" v-if="ruleForm.hopeMinSalary != 0">
                <el-select
                  v-model="ruleForm.hopeMaxSalary"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- 求职类型 -->
            <div class="input-place">
              <p
                v-for="(item, index) in listArr"
                :key="index"
                :class="ruleForm.jobType == item.id ? 'Select-p' : ''"
                @click="handelStanDing(item)"
              >
                {{ item.name }}
              </p>
            </div>
          </el-form>
        </div>
        <div class="Edit-Avatar">
          <!-- 编辑栏 右上角删除icon -->
          <div
            class="Edit-Avatar-box firm-clickable"
            @click="handelDelete"
            v-if="ApplyForAJob != '1' && data.length > 1"
          ></div>
        </div>
      </div>
      <!-- 编辑栏下方按钮样式 -->
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
    <!-- 职位 -->
    <Position
      :PositionAndProfession="PositionAndProfession"
      :positionCode="ruleForm.positionCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Position>
    <!-- 地址 -->
    <Address
      :dialogAddress="dialogAddress"
      :distinguish="1"
      :addressCode="ruleForm.addressCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Address>
    <!-- 行业 -->
    <Profession
      :industryTypeList="industryTypeList"
      :dialogProfession="dialogProfession"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Profession>
  </div>
</template>

<script>
// /职位选择弹窗
import Position from "../../../../../../components/Position.vue";
// /行业选择弹窗
import Profession from "../../../../../../components/Profession.vue";
// /地址选择弹窗
import Address from "../components/addres.vue";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";

// 引入接口
import {
  addUserJobIntention, // 添加求职意向
  editUserJobIntention, // 编辑
  deleteUserJobIntention, //删除
} from "../../../../../../assets/api/CenterJane";
export default {
  // 接收父组件传递的参数
  props: {
    data: {},
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "面议",
        },
        {
          value: 1000,
          label: "1k",
        },
        {
          value: 2000,
          label: "2k",
        },
        {
          value: 3000,
          label: "3k",
        },
        {
          value: 4000,
          label: "4k",
        },
        {
          value: 5000,
          label: "5k",
        },
        {
          value: 6000,
          label: "6k",
        },
        {
          value: 7000,
          label: "7k",
        },
        {
          value: 8000,
          label: "8k",
        },
        {
          value: 9000,
          label: "9k",
        },
        {
          value: 10000,
          label: "10k",
        },
        {
          value: 11000,
          label: "11k",
        },
        {
          value: 12000,
          label: "12k",
        },
        {
          value: 13000,
          label: "13k",
        },
        {
          value: 14000,
          label: "14k",
        },
        {
          value: 15000,
          label: "15k",
        },
        {
          value: 16000,
          label: "16k",
        },
        {
          value: 17000,
          label: "17k",
        },
        {
          value: 18000,
          label: "18k",
        },
        {
          value: 19000,
          label: "19k",
        },
        {
          value: 20000,
          label: "20k",
        },
        {
          value: 21000,
          label: "21k",
        },
        {
          value: 22000,
          label: "22k",
        },
        {
          value: 23000,
          label: "23k",
        },
        {
          value: 24000,
          label: "24k",
        },
        {
          value: 25000,
          label: "25k",
        },
        {
          value: 26000,
          label: "26k",
        },
        {
          value: 27000,
          label: "27k",
        },
        {
          value: 28000,
          label: "28k",
        },
        {
          value: 29000,
          label: "29k",
        },
        {
          value: 30000,
          label: "30k",
        },
        {
          value: 35000,
          label: "35k",
        },
        {
          value: 40000,
          label: "40k",
        },
        {
          value: 45000,
          label: "45k",
        },
        {
          value: 50000,
          label: "50k",
        },
        {
          value: 55000,
          label: "55k",
        },
        {
          value: 60000,
          label: "60k",
        },
      ], // 期望薪资下拉框数据
      options1: [], // 期望薪资最高选择，选择最低后给options1赋值
      ruleForm: {
        id: "",
        userId: "",
        positionName: "", //职位
        positionCode: "", // 职位code
        industryTypeList: [], // 行业
        industryTypeName: "", // 行业拼接用来展示的名
        addressName: "", // 地点
        addressCode: "", // 地点code
        hopeMaxSalary: "", // 薪资高
        hopeMinSalary: "", // 薪资低
        jobType: "0", // 求职类型
      }, // 选择框数据

      rules: {
        positionName: [
          {
            required: true,
            message: "请选择职位",
            trigger: ["blur", "change"],
          },
        ],
        // positionName: vxRule(true, "", ["blur", "change"]),
        industryTypeName: vxRule(true, "", ["blur", "change"], "请选择期望行业"),
        addressName: vxRule(true, "", ["blur", "change"], "请选择期望地点"),
        hopeMinSalary: vxRule(true, "", ["blur", "change"], "请输入期望最低薪资"),
        hopeMaxSalary: vxRule(true, "", ["blur", "change"], "请输入期望最高薪资"),
      }, // 表单验证
      userArr: [
        { name: "期望职位", required: "1" },
        { name: "期望行业", required: "1" },
        { name: "期望地点", required: "1" },
        { name: "期望薪资", required: "1" },
        { name: "求职类型", required: "1" },
      ], // ipt名用于循环生成 input1的标题
      listArr: [
        { name: "全职", id: "0" },
        { name: "兼职", id: "1" },
      ], // 兼职全职选择
      Select: "0", // 兼职全职选中
      certain: 1, // 点击编辑  编辑某一条
      PositionAndProfession: false, //选择职位弹窗
      dialogAddress: false, // 选择地址
      dialogProfession: false, //选择行业
      index: "", // 接口修改前是为了获取被编辑项的位置  接口修改后是存被修改项的id
      industryTypeList: [{ code: "" }], // 行业 对象形式展示用于传给行业选择组件回显
      ApplyForAJob: "", // 为1时说明是在添加新的求职意向
    };
  },
  watch: {
    // 监听 年龄是否满16
    data: {
      handler(newSs, old) {
        console.log(newSs, "new");
        // this.industryTypeArr =
      },
    },
    certain: {
      handler(newSs, old) {
        console.log(newSs, "new");
        if (newSs == 1) {
          this.ruleForm = {
            id: "",
            userId: "",
            positionName: "", //职位
            positionCode: "", // 职位code
            industryTypeList: [], // 行业
            industryTypeName: "", // 行业拼接用来展示的名
            addressName: "", // 地点
            addressCode: "", // 地点code
            hopeMaxSalary: "", // 薪资高
            hopeMinSalary: "", // 薪资低
            jobType: "0", // 求职类型
          }; // 选择框数据
        }
      },
    },
    // // 监听表单验证状态

    // "ruleForm.positionName": function (newSs, old) {
    //   this.rules = {
    //     positionName: vxRule(true, "", ["blur", "change"]),
    //   }; // 表单验证
    // },
  },

  created() {
    console.log(this.data);
  },
  components: {
    Position,
    Address,
    Profession,
  },
  methods: {
    // ---------------------------------- 点击添加
    handelClickEDITOR() {
      if (this.data.length >= 6) {
        this.$tool.PromptBox("warning", "最多可添加6条意向");
      } else {
        this.certain = "2";
        this.ruleForm = {
          id: "",
          userId: "",
          positionName: "",
          positionCode: "",
          industryTypeList: [],
          industryTypeName: "",
          addressName: "",
          addressCode: "",
          hopeMaxSalary: "",
          hopeMinSalary: "",
          jobType: "0",
        };
        this.industryTypeList = [{ code: "" }];
        this.ApplyForAJob = "1";
      }
    },
    // --------------------------------------选择最低薪资后
    handelChange(val, isEcho = false) {
      for (var i in this.options) {
        if (this.options[i].value == val) {
          // 截取选择最低薪资后的六种薪资待遇赋值给options1最高薪资的选择
          // 从最低薪资的下一位开始，确保最高薪资始终大于最低薪资
          this.options1 = this.options.slice(Number(i) + 1, Number(i) + 7);
        }
      }
      console.log(val , 'val' , this.options1)
      // 选择最低薪资时清空最高薪资，但回显时不清空
      if (!isEcho) {
        if (val == 0) {
          this.ruleForm.hopeMaxSalary = 0;
        } else {
          this.ruleForm.hopeMaxSalary = "";
        }
      }
    },
    // -------------------------------------选择职位 弹窗关闭
    handleClose(num) {
      if (num == 0) {
        // 0关闭职位选择弹窗
        this.PositionAndProfession = !this.PositionAndProfession;
      } else if (num == 1) {
        this.dialogProfession = !this.dialogProfession;
      } else if (num == 2) {
        // 2 关闭地址选择弹窗
        this.dialogAddress = !this.dialogAddress;
      }
    },
    //-----------------------------------选择职位 弹窗确认
    handleUnderstand(num, val, valTwe) {
      if (num == 0) {
        this.ruleForm.positionName = valTwe;
        this.ruleForm.positionCode = val;
        // 0关闭职位选择弹窗
        this.PositionAndProfession = !this.PositionAndProfession;
      } else if (num == 1) {
        console.log(num, val, valTwe);
        // 1行业选择弹窗
        var arr = [];
        var arr1 = [];
        for (var i in val) {
          var obj = {
            name: "",
            code: "",
          };
          obj.name = val[i].label;
          obj.code = val[i].code;
          arr1[i] = obj;
          // this.ruleForm.industryTypeList[i] = obj;
          arr[i] = val[i].label;
        }

        this.ruleForm.industryTypeList = arr1;
        this.ruleForm.industryTypeName = arr.join(",");

        this.dialogProfession = !this.dialogProfession;
      } else if (num == 2) {
        // 2 关闭地址选择弹窗
        this.dialogAddress = !this.dialogAddress;
        // 获取到选择的地点、
        this.ruleForm.addressName = valTwe;
        this.ruleForm.addressCode = val;
      }
    },
    // --------------------------------------点击选择 职位
    handelExpect(num) {
      // 打开弹窗
      if (num == 1) {
        // 打开职位选择弹窗
        this.PositionAndProfession = true;
      } else if (num == 2) {
        // 打开行业选择
        this.dialogProfession = true;
      } else {
        // 打开地址选择
        this.dialogAddress = true;
      }
    },
    // ----------------------------------点击某个 意向进行编辑
    handelIndividualEdit(item, index) {
      this.certain = 2;
      this.index = item.id; // 获取要编辑的数据位置
      let newArr1 = JSON.parse(JSON.stringify(this.data[index]));
      this.industryTypeList = JSON.parse(newArr1.industryTypeList);
      this.ruleForm = newArr1; // 数据回显

      this.ruleForm.industryTypeList = this.industryTypeList;
      // 回显时设置最高薪资选项，但不清空最高薪资值
      this.handelChange(item.hopeMinSalary, true); // 薪资范围确认，第二个参数表示是回显
      
      // 根据addressCode重新构建完整的地址名称
      if (this.ruleForm.addressCode && this.ruleForm.addressCode.length > 0) {
        this.rebuildAddressName(this.ruleForm.addressCode);
      }
      
      this.ApplyForAJob = "";
    },
    // 根据addressCode重建地址名称
    rebuildAddressName(addressCode) {
      // 从Vuex获取地址数据
      const addressList = this.$store.getters.getAddRes;
      if (!addressList || addressList.length === 0) return;
      
      let provinceName = "";
      let cityName = "";
      let areaName = "";
      
      // 解析addressCode
      const provinceCode = addressCode.substr(0, 2);
      const cityCode = addressCode.length >= 4 ? addressCode.substr(0, 4) : "";
      const areaCode = addressCode;
      
      // 查找省
      const province = addressList.find(item => item.code == provinceCode);
      if (province) {
        provinceName = province.label;
        // 查找市
        if (province.children && cityCode) {
          const city = province.children.find(item => item.code == cityCode);
          if (city) {
            cityName = city.label;
            // 查找区
            if (city.children && addressCode.length == 6) {
              const area = city.children.find(item => item.code == areaCode);
              if (area) {
                areaName = area.label;
              }
            }
          }
        }
      }
      
      // 构建完整地址名称
      let fullAddress = provinceName;
      if (cityName) {
        fullAddress += "-" + cityName;
      }
      if (areaName) {
        fullAddress += "-" + areaName;
      }
      
      this.ruleForm.addressName = fullAddress;
    },
    // ---------------------------------点击选择求职状态
    handelStanDing(item) {
      this.ruleForm.jobType = item.id;
    },
    // ----------------------------------取消编辑
    handelUnEdit() {
      // 取消编辑清空 已输入数据
      this.industryTypeList = [];

      this.index = "";
      this.$emit("handelUnEdit", 2);
      // this.certain是子组件中的数据所以在给父组件传值/事件时可直接在子组件进行修改父组件数据要在父组件中修改避免报错
      this.certain = 1;
      this.ApplyForAJob = "";
    },
    // -----------------------------------------编辑提交
    handelSubmitEdit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验最高薪资是否低于最低薪资
          if (this.ruleForm.hopeMinSalary && this.ruleForm.hopeMaxSalary &&
              Number(this.ruleForm.hopeMaxSalary) < Number(this.ruleForm.hopeMinSalary)) {
            this.$tool.PromptBox("error", "最高薪资不能低于最低薪资");
            return false;
          }
          if (this.ApplyForAJob == "") {
            // 编辑
            var data = {};
            this.ruleForm.id = this.index;
            this.ruleForm.userId = this.$store.getters.getUser.id;

            const val = this.ruleForm.industryTypeList;

            if (typeof val === "string") {
              console.log("字符串");
            } else {
              console.log("json");
              this.ruleForm.industryTypeList = JSON.stringify(
                this.ruleForm.industryTypeList
              );
            }

            data.data = JSON.parse(JSON.stringify(this.ruleForm));

           
            console.log(data, "data");
            // 调用接口修改简历个人信息
            editUserJobIntention(data).then((res) => {
              if (res.code == 0) {
                this.$emit("handelSubmitEdit", 2);
                this.certain = 1;
                this.ApplyForAJob = "";
                this.index = "";
                // 成功
                this.$tool.PromptBox("success", "修改成功");
                this.industryTypeList = [];
                // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
              } else {
                // 失败
                // this.$tool.PromptBox("error", res.msg);
              }
            });
          } else {
            // 为添加，在原来的数据前新增一条

            var data = {};
            this.ruleForm.userId = this.$store.getters.getUser.id;

            if (typeof val === "string") {
              console.log("字符串");
            } else {
              console.log("json");
              this.ruleForm.industryTypeList = JSON.stringify(
                this.ruleForm.industryTypeList
              );
            }
            data.data = JSON.parse(JSON.stringify(this.ruleForm));

            // 校验最高薪资是否低于最低薪资
            if (this.ruleForm.hopeMinSalary && this.ruleForm.hopeMaxSalary &&
                Number(this.ruleForm.hopeMaxSalary) < Number(this.ruleForm.hopeMinSalary)) {
              this.$tool.PromptBox("error", "最高薪资不能低于最低薪资");
              return false;
            }

            // // 调用接口修改简历个人信息
            addUserJobIntention(data).then((res) => {
              if (res.code == 0) {
                this.$emit("handelSubmitEdit", 2);
                this.certain = 1;
                this.ApplyForAJob = "";
                this.index = "";
                // 成功
                this.$tool.PromptBox("success", "修改成功");
                this.industryTypeList = [];
                // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
              } else {
                // 失败
                // this.$tool.PromptBox("error", res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // --------------------------------------- 删除确认
    handelDelete() {
      this.$confirmWithScroll("是否删除本条信息?", "提示").then(() => {
        var data = {
          data: {
            userId: this.$store.getters.getUser.id,
            id: this.index,
          },
        };
        deleteUserJobIntention(data).then((res) => {
          if (res.code == 0) {
            this.$emit("handelSubmitEdit", 2);
            this.certain = 1;
            this.ApplyForAJob = "";
            this.index = "";
            this.$tool.PromptBox("success", "修改成功");
            this.industryTypeList = [];
          }
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;

  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// select框的icon
/deep/.el-icon-arrow-up {
  margin-top: 0px !important;
}
// 调整el组件库input框的样式
/deep/.el-input__inner {
  width: 360px;
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  //   border-right: none;
}
/deep/ .el-date-editor--date {
  width: 360px !important;
}
// input框自带icon
/deep/.el-input__icon {
  font-size: 20px !important;
  margin-top: -3px;
}
// 正常显示数据
.normal {
  width: 100%;
  min-height: 25px;
  border: 1px solid transparent;
  position: relative;
}
// 显示编辑框
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}
// 添加icon样式
.Title-Add-box {
  display: flex;
  position: absolute;
  font-size: 12px;
  top: -45px;
  left: 120px;
}
.Title-Add {
  width: 18px;
  height: 18px;
  background-image: url("../../../../../../assets/imgs/tianjia@2x.svg");
  background-size: 100% 100%;
  margin: auto 0;
  margin-left: 30px;
  margin-right: 5px;
}
// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据显示待添加
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  // 有数据正常展示
  .normal-show {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    // 正常展示数据
    .normal-show-box {
      width: 100%;
      height: 20px;
      line-height: 20px;
      display: flex;
      //
      p {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #666666;
        font-weight: 400;
        margin-right: 50px;
      }
      // 职位
      .Position-name {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        margin-right: 10px;
      }
      // 兼职
      .Part-time {
        width: 32px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/jianzhi@3x.svg");
        background-size: 100% 100%;
      }
      // 全职
      .full-time {
        width: 32px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/quanzhi@3x.svg");
        background-size: 100% 100%;
      }
      // 编辑按钮
      .Edit-button {
        width: 18px;
        height: 18px;
        margin: auto 0;
        background-image: url("../../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
        margin-left: 30px;
      }
    }
    .normal-show-box:nth-child(1) {
      margin-bottom: 10px;
    }
  }
  .normal-show:nth-child(1) {
    margin-top: 0px;
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  .EDITOR-top {
    width: 100%;
    display: flex;
    // input右侧标题
    .EDITOR-top-title {
      min-width: 100px;
      height: 100%;
      p {
        height: 35px;
        text-align: right;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        text-align: right;
        line-height: 35px;
        font-weight: 400;
        margin-bottom: 25px;
      }
    }
    // 放input的div
    .EDITOR-top-ipt {
      width: 350px;
      height: 100%;
      .input-place {
        width: 100%;
        height: 35px;
        margin-top: 25px;
        display: flex;
        position: relative;
        // 两个选择框中间的 至
        .SelectTo {
          width: 50px;
          height: 35px;
          font-size: 14px;
          text-align: center;
          line-height: 35px;
        }
        .Select-p {
          background: rgba(97, 144, 232, 0.27);
        }
        p {
          margin-left: 15px;
          min-width: 90px;
          height: 35px;
          line-height: 35px;
          background: #ffffff;
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #409eff ;
          text-align: center;
          font-weight: 400;
        }
        p:nth-child(1) {
          margin-left: 0;
        }
      }
      .input-place:nth-child(1) {
        margin-top: 0;
      }
    }
    // 编辑框右上角 删除icon
    .Edit-Avatar {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .Edit-Avatar-box {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
        background-size: 100% 100%;
      }
    }
  }
  // 编辑栏下方按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
